var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#206BB1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1665 23.7083H11.8332C8.7915 23.7083 7.0415 21.9583 7.0415 18.9167V13.0833C7.0415 10.0417 8.7915 8.29166 11.8332 8.29166H20.1665C23.2082 8.29166 24.9582 10.0417 24.9582 13.0833V18.9167C24.9582 21.9583 23.2082 23.7083 20.1665 23.7083ZM11.8332 9.54166C9.44984 9.54166 8.2915 10.7 8.2915 13.0833V18.9167C8.2915 21.3 9.44984 22.4583 11.8332 22.4583H20.1665C22.5498 22.4583 23.7082 21.3 23.7082 18.9167V13.0833C23.7082 10.7 22.5498 9.54166 20.1665 9.54166H11.8332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.725C15.3 16.725 14.5916 16.5083 14.05 16.0666L11.4416 13.9833C11.175 13.7666 11.125 13.375 11.3416 13.1083C11.5583 12.8416 11.95 12.7916 12.2166 13.0083L14.825 15.0916C15.4583 15.6 16.5333 15.6 17.1666 15.0916L19.775 13.0083C20.0416 12.7916 20.4416 12.8333 20.65 13.1083C20.8666 13.375 20.825 13.775 20.55 13.9833L17.9416 16.0666C17.4083 16.5083 16.7 16.725 16 16.725Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.42f98e3db2a8f17d2bb75911601c3d60.svg";
export { ForwardRef as ReactComponent };